import Auth from '@/app/views/Auth.vue';

export default {
  path: '/auth/:state',
  name: 'auth',
  component: Auth,
  meta: { requiresAuth: false },
};
